import urlRoutes from '../../config/url-routes';

export default () => [
  {
    label: 'Sair',
    click: urlRoutes.logout,
  }
];
